import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useMobileDetect } from "@hooks/index";
import styles from "./announcementBar.module.css";

const Stores = () => {
  const { t } = useTranslation("navbar");
  return (
    <div className={styles.announcementLink}>
      <Link href="https://kotn.com/stores" passHref prefetch={false}>
        <a>{t("stores")}</a>
      </Link>
    </div>
  );
};


const BeitKotn = () => {
  return (
    <div className={styles.announcementLink}>
      <Link href="https://kotn.com/beit-kotn" passHref prefetch={false}>
        <a>Beit Kotn</a>
      </Link>
    </div>
  );
};


export function AnnouncementBarRight() {
  const currentDevice = useMobileDetect();
  const isMobile = currentDevice.isMobile();

  return (
    <div className={styles.announcementRight}>
      {!isMobile && <BeitKotn />}
      {!isMobile && <Stores />}
    </div>
  );
}
